// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CSFTitle_wrapper__2JDu0","greenArrow":"CSFTitle_greenArrow__2jonZ","contentWrapper":"CSFTitle_contentWrapper__rSdp9"};